import PillEditor from "Shared/components/PillEditor/PillEditor"
import './HeadingBlock.scoped.scss'
import LiquidValidator from 'Shared/components/LiquidValidator/LiquidValidator'

const headingTag = (tag, content) => {
  if (tag === 'h2') return <h2>{content}</h2>
  if (tag === 'h3') return <h3>{content}</h3>
  if (tag === 'h4') return <h4>{content}</h4>
  return <h1>{content}</h1>
}

const HEADING_STYLES = {
  'h1': { fontSize: 34, fontFamily: 'Helvetica, Arial, sans-serif;' },
  'h2': { fontSize: 30, fontFamily: 'Helvetica, Arial, sans-serif;' },
  'h3': { fontSize: 28, fontFamily: 'Helvetica, Arial, sans-serif;' },
  'h4': { fontSize: 24, fontFamily: 'Helvetica, Arial, sans-serif;' },
}

const HeadingBlock = ({ block, active }) => {
  const { parameters: { text, tag, fontFamily } } = block
  const act = useAct()
  const { mergeTags } = useSel(s => s.campaignBuilder)
  const selector = `#block_${block.id} .injected-styles span`
  const mergeTagTests = useSel((s) => _.values(s.mergeTagTests.entities))
  
  const allMergeTags = () => { // combines mergeTags and mergeTagTests
    if (!mergeTagTests || mergeTagTests.length == 0) {
      return mergeTags;
    }
    return {...mergeTags, "Experiments": mergeTagTests.map(t => ({ label: t.name, slug: 'tests.' + t.slug, featured: false }))}; 
  }
  
  const updateText = (text) => act.email.blocks.updateParameters(block.id, {text})

  const dynamicFontFamily = fontFamily || HEADING_STYLES[tag].fontFamily

  return <div id={`block_${block.id}`}>
    <style>
      {`${selector} {
        font-size: ${HEADING_STYLES[tag].fontSize}px !important;
        font-family: ${dynamicFontFamily} !important;
      }`}
    </style>

    { active && <div className='editor-container'>
      <PillEditor condensed initialValue={block.parameters.text} onChange={updateText} availableTags={mergeTags} />
      <LiquidValidator value={block.parameters.text} lineSplitTags={true} availableTags={allMergeTags()} />
    </div> }
    { !active && headingTag(tag, text) }
  </div>
}

export default HeadingBlock
